/**
 * @fileoverview Estados de carga das Configurações: o carregando (antes dos
 * dados, a tela não afirma nada) e o erro com "Tentar de novo" (em vez de uma
 * lista vazia ou de um "desativado" que não foi confirmado).
 */

import React from "react";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { tokens } from "../Triage/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => {
  const dark = theme.palette.type === "dark";
  const c = tokens(dark);
  return {
    center: { padding: 32, display: "flex", justifyContent: "center", color: c.textMuted },
    errorBox: {
      padding: "20px",
      borderRadius: 12,
      border: `1px solid ${c.border}`,
      background: c.surface,
      color: c.textSecondary,
      fontSize: 13,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      flexWrap: "wrap",
    },
    retryButton: {
      height: 34,
      padding: "0 14px",
      borderRadius: 8,
      border: `1px solid ${c.inputBorder}`,
      background: "transparent",
      color: c.textPrimary,
      fontSize: 13,
      fontWeight: 500,
      fontFamily: "inherit",
      cursor: "pointer",
      "&:hover": { background: c.hover },
      "&:focus-visible": {
        outline: "none",
        boxShadow: `0 0 0 2px ${dark ? "rgba(255,255,255,0.4)" : "rgba(15,23,42,0.4)"}`,
      },
    },
  };
});

export const LoadingState = () => {
  const classes = useStyles();
  return (
    <div className={classes.center}>
      <CircularProgress size={22} color="inherit" />
    </div>
  );
};

// `message`: texto próprio da seção (o padrão é o genérico das Configurações).
export const LoadError = ({ onRetry, message }) => {
  const classes = useStyles();
  return (
    <div className={classes.errorBox} role="alert">
      <span>{message || i18n.t("settings.area.loadError")}</span>
      {onRetry && (
        <button type="button" className={classes.retryButton} onClick={onRetry}>
          {i18n.t("settings.area.retry")}
        </button>
      )}
    </div>
  );
};
